import styled from '@emotion/styled';
import { inkFontTokens } from '@ds/tokens';

const ContainerLayoutFooterDisclaimer = styled.div`
    color: ${inkFontTokens.fontColorSubtle};
    ${inkFontTokens.fontDetailS};
    flex: 2;
`;

export default ContainerLayoutFooterDisclaimer;
